import { render, staticRenderFns } from "./news1.vue?vue&type=template&id=91fbdf3e"
import script from "./news1.vue?vue&type=script&lang=js"
export * from "./news1.vue?vue&type=script&lang=js"
import style0 from "./news1.vue?vue&type=style&index=0&id=91fbdf3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports